export class CashSessionStatuses {
    public static ACTIVE = 'ACTIVE';
    public static PENDING = 'PENDING';
    public static COMPLETE = 'COMPLETE';
    public static DELETED = 'DELETED';
}
